import { useState } from 'react'
import FundoRosaHome from '../../../assets/fundo-rosa-home.png'
import IconArrowDown from '../../../assets/icons/ico-arrow-down.png'
import Info from '../../ui/info/info'
import { Col, Row } from '../../ui'
import { useCategoryFarm } from '../../../contexts/category-farm-context'
import { Container } from './styles'
import { getToken } from 'infra/services/auth'
import Loading from 'presentation/components/ui/loading/loading'
import IconArrowLeft from '../../../assets/icons/ico-arrow-left.png'
import { Link, useHistory } from 'react-router-dom'
import { translate } from '../../../../i18n/index'

const BaseLayoutEntry = ({ children }) => {
  const { categoryFarm } = useCategoryFarm()
  const [Open, setOpen] = useState(false)
  const farmName = window.localStorage.getItem('farm-name') ? atob(window.localStorage.getItem('farm-name')) : ''
  const farmKey = window.localStorage.getItem('farm-api-key') ? atob(window.localStorage.getItem('farm-api-key')) : ''

  const history = useHistory<any>()
  const token = getToken()
  const pathPrevious = history.location.state

  return (
    <Container>
      {token &&
        <>
          <div className='return-action'>
            <Link to={pathPrevious}>
              <img src={IconArrowLeft} alt="Icone de flecha para esquerda" />
            </Link>
            <h3>{translate('labelRetornar')}</h3>
          </div>
          <img src={FundoRosaHome} className="wave" alt="Onda cor rosa" />
          <Row>
            {/* <Col width={40} gutter={31}> */}
            <Col width={45} gutter={25}>
              <div className="home-text">
                <div className="home-text-title" onClick={() => setOpen(!Open)}>
                  <h1>{categoryFarm?.title}</h1>
                  <img className="home-text-icon" src={IconArrowDown} alt="icone de seta para baixo" />
                </div>
                {token && farmKey && farmName && <h4>#{farmKey} - {farmName}</h4>}
              </div>
            </Col>
            <Col width={29}>
              <Info />
            </Col>
          </Row>
        </>
      }
      {!token && <Loading />}
      {children}
    </Container>
  )
}

export default BaseLayoutEntry
